import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ecm-visitor-header',
    templateUrl: 'visitor-header.html',
    styleUrls: ['visitor-header.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule],
})
export class VisitorHeaderComponent {}
